import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-facebook",
  templateUrl: "./med-icon-facebook.component.html",
})
export class MedIconFacebookComponent extends SvgMixinComponent {}
